<div class="card">
  <p-toolbar>
    <ng-template #start>
      <p-image src="logo.png" [width]="'350px'" class="cursor-pointer" (click)="go('')"></p-image>
    </ng-template>
    <ng-template #center>
      <div class="space-x-2">
        @if (auth.isAuthenticated()) {
          <p-button (click)="go('')">{{ 'app:header:button:home' | translate }}</p-button>
          <p-button (click)="menu.toggle($event)">{{ 'app:header:button:my-products' | translate }}<i
            class="pi pi-chevron-down"></i></p-button>
          <p-menu #menu [model]="menuItems()" [popup]="true">

            <ng-template #item let-item>
              <a pRipple [href]="item.url" class="flex flex-row space-x-2 items-center px-3 py-2 cursor-pointer">
                <i class="pi" [ngClass]="{'pi-star': !item.favorited, 'pi-star-fill': item.favorited}"
                   (click)="toggleFavorite($event, item)"></i>
                <span>{{ item.label }}</span>
              </a>
            </ng-template>

          </p-menu>
          <!--          <p-button >{{ 'app:header:button:resources' | translate }}</p-button>-->
        }
      </div>
    </ng-template>
    <ng-template #end>
      @if (auth.isAuthenticated()) {
        <!--        <p-button [rounded]="true">-->
          <!--           If this needs a value, we will need to override the size of the badge, It is set in styles.scss-->
          <!--          <p-overlaybadge badgeSize="small" severity="danger" [dt]="{}">-->
          <!--            <i class="pi pi-bell"></i>-->
          <!--          </p-overlaybadge>-->
          <!--        </p-button>-->
          <!--        <p-divider layout="vertical"></p-divider>-->
        @if (this.adminMenuItems().length > 0) {
          <p-button (click)="adminMenu.toggle($event)">
            <i [class]="'icon.settings' | translate"></i>
            <i class="pi pi-chevron-down transition-transform duration-200"
               [class.rotate-180]="adminMenu.visible"></i>
          </p-button>
          <p-menu #adminMenu [model]="adminMenuItems()" [popup]="true"/>
          <p-divider layout="vertical"></p-divider>
        }

        <div class="cursor-pointer flex flex-row" (click)="menu.toggle($event)">
          <div>
            <div>{{ auth.fullName() }}</div>
            <p-chip [label]="title()"></p-chip>
          </div>
          <div class="px-2">
            <div class="avatar">
              <img lib-ImageFallback [imageFallback]="'profile'" alt="profile image" [src]="image()"/>
            </div>
          </div>
        </div>
        <p-menu #menu [model]="userMenuItems()" [popup]="true"/>
      }
    </ng-template>
  </p-toolbar>
</div>

<p-toast position="bottom-center"></p-toast>
